export default "__VITE_ASSET__BE48BJw$__"